import { useState } from 'react';
import { ScrumForm } from './scrum-form';
import { ScrumList } from './scrum-list';
import { ScrumRoster } from './scrum-roster';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp, Users, EyeOff } from 'lucide-react';
import { format } from 'date-fns';

export function ScrumBoard() {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [showRoster, setShowRoster] = useState(false);
  const [hideEmptyMembers, setHideEmptyMembers] = useState(false);
  const currentDate = format(new Date(), 'PPPP');

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold">Daily Huddle Meeting</h1>
            <p className="text-gray-500 dark:text-gray-400 mt-1">{currentDate}</p>
          </div>
          <div className="flex items-center gap-2">
            {showRoster && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => setHideEmptyMembers(!hideEmptyMembers)}
                className="flex items-center gap-2"
              >
                <EyeOff className="w-4 h-4" />
                {hideEmptyMembers ? 'Show All Members' : 'Hide Members Without Tasks'}
              </Button>
            )}
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowRoster(!showRoster)}
              className="flex items-center gap-2"
            >
              <Users className="w-4 h-4" />
              {showRoster ? 'Hide' : 'Show'} Team Roster
            </Button>
          </div>
        </div>
      </div>

      {showRoster && (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
          <h2 className="text-lg font-semibold mb-4">Team Roster & Tasks</h2>
          <ScrumRoster hideEmptyMembers={hideEmptyMembers} />
        </div>
      )}

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-700">
          <h2 className="text-lg font-semibold">Create New Huddle</h2>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsFormVisible(!isFormVisible)}
            className="flex items-center gap-2"
          >
            {isFormVisible ? (
              <>
                <ChevronUp className="w-4 h-4" />
                Hide Form
              </>
            ) : (
              <>
                <ChevronDown className="w-4 h-4" />
                Show Form
              </>
            )}
          </Button>
        </div>
        
        <div
          className={`transition-all duration-300 ease-in-out ${
            isFormVisible ? 'max-h-[2000px] opacity-100' : 'max-h-0 opacity-0'
          } overflow-hidden`}
        >
          <div className="p-6">
            <ScrumForm />
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <h2 className="text-lg font-semibold">Huddles Log</h2>
        <ScrumList />
      </div>
    </div>
  );
}